import * as React from 'react';

import { IColorValues } from '../../types';
import { BrandColorValue } from '../BrandColorValue';

import { IBrandColorCardProps } from './types';

import * as s from './BrandColorCard.scss';

export const BrandColorCard = ({
	color: {
		title,
		values,
	},
	isMainColor,
}: IBrandColorCardProps) => {
	const onColorBoxClick = (colorValues: IColorValues) => () => {
		void navigator.clipboard?.writeText?.(colorValues.hex);
	};

	return (
		<div className={isMainColor ? s.mainColor : s.auxColor}>
			<div className={s.colorName}>
				{title}
			</div>
			<div className={s.content}>
				<div
					className={s.colorBox}
					style={{
						backgroundColor: values.hex,
					}}
					onClick={onColorBoxClick(values)}
				/>
				<div className={s.colorValues}>
					{Object.keys(values).map((key: keyof IColorValues) => (
						<BrandColorValue
							key={key}
							isMainColor={isMainColor}
							title={key}
							value={values[key]}
						/>
					))}
				</div>
			</div>
		</div>
	);
};
